import { fittingLooks } from '@/data/fittingLooks';

// Fitting 页面：视频和 30 套 lookbook 数据驱动渲染，布局沿用 styles.css 中的原站样式类。
export default function FittingPage() {
  return (
    <main>
      <section className="section fitting-section">
        <div className="fitting-heading-top">
          <p className="section-title">Fitting</p>
        </div>

        <div className="fitting-video-block">
          <video
            className="fitting-video"
            playsInline
            controls
            preload="none"
            poster="/assets/art-projects/evacuate-from-meaning/cover.jpg"
          >
            <source src="/assets/fitting-intro.mp4" type="video/mp4" />
          </video>
        </div>

        <div className="fitting-intro">
          <div className="fitting-heading-block">
            <h1 className="fitting-heading">SS26</h1>
          </div>
          <div className="fitting-intro-copy">
            <p className="fitting-copy">
              Thirty looks from the collection, named through silhouette, material, tension, and
              mood rather than sequence alone.
            </p>
          </div>
        </div>

        <div className="fitting-divider" />

        {/* 造型卡片由数组 map 生成，新增/调整顺序只改 src/data/fittingLooks.js。 */}
        <div className="lookbook-grid">
          {fittingLooks.map((look) => (
            <article className="look-card" key={look.number}>
              <div className="look-frame look-frame--uniform">
                <img
                  loading="lazy"
                  decoding="async"
                  src={look.image}
                  alt={`Look ${look.number}`}
                  className={`look-image look-image--uniform${look.number === 4 ? ' look-image--look4' : ''}`}
                />
              </div>
              <div className="look-copy">
                <p className="look-label">Look {look.number}</p>
                <h2 className="look-title">{look.title}</h2>
                <p className="look-description">{look.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
